<template>
  <div class="main profile vld-parent">

    <loading v-model:active="isLoading"
             :is-full-page="false"
             color="var(--primary-color)"></loading>
    <select-themes ref="selectThemes" v-on:submit="saveThemes"
                   v-if="selectThemes"
                   v-bind:preferred_booth="userData.preferred_booth"
                   v-bind:user-themes="userData.themes"
                   v-bind:user-role="userData.role"
                   v-bind:start-tab-id="selectThemesStartTabId" :isUpdate="true"></select-themes>

    <!-- Confirm Themes Dialog -->
    <custom-dialog :id="'confirm-themes-dialog'" ref="confirmThemesDialog"
                   :on-submit="saveThemesAfterConfirmWithRedirect"
                   :on-second-button-submit="closeThemeSelectWithRedirect"
                   :submit-button-text="$t('dialog-yes')"
                   :second-button-text="$t('dialog-no')">
      <span class="header">{{ $t('confirm-theme-changes') }}</span>
    </custom-dialog>


    <template v-if="!selectThemes">
      <custom-dialog id="complete-profile-wizard-dialog" ref="completeProfilewizardDialog"
                     :disable-buttons="true" :on-cancel="onProfileWizardCancel">
        <form-wizard
            :subtitle="''"
            :color="'var(--wizard-color)'"
            :next-button-text="$t('next')"
            :back-button-text="$t('back')"
            :finish-button-text="$t('save')"
            @on-complete="saveUserDataFromwizard"
            class="profile-wizard">

          <template slot="title">
            <div>{{ $t('complete-profile') }}</div>
          </template>


          <tab-content :title="$t('position')" class="tab-content">
            <div class="tab-content-input-wrapper">
              <span>{{ $t('wizard-position') }}</span>
              <CustomInputText v-model:value="userDataNotProvidedByMbf.position"
                               v-bind:place-holder="$t('position')"></CustomInputText>
            </div>
          </tab-content>
          <tab-content :title="$t('phone')" class="tab-content">
            <div class="tab-content-input-wrapper">
              <span>{{ $t('wizard-tel') }}</span>
              <CustomInputText v-model:value="userDataNotProvidedByMbf.tel"
                               v-bind:place-holder="$t('phone')"></CustomInputText>
            </div>

          </tab-content>
          <tab-content title="URL" class="tab-content">
            <div class="tab-content-input-wrapper">
              <span>{{ $t('wizard-url') }}</span>
              <CustomInputUrl v-model:value="userDataNotProvidedByMbf.web"
                              v-bind:place-holder="$t('website-url')"></CustomInputUrl>
            </div>

          </tab-content>
          <tab-content title="LinkedIn" class="tab-content">
            <div class="tab-content-input-wrapper">
              <span>{{ $t('wizard-linkedin') }}</span>
              <CustomInputUrl v-model:value="userDataNotProvidedByMbf.linkedin"
                              prefix="https://www.linkedin.com/in/"
                              v-bind:place-holder="$t('linkedin-profile-url')"></CustomInputUrl>
            </div>
          </tab-content>

          <tab-content title="X" class="tab-content">
            <div class="tab-content-input-wrapper">
              <span>{{ $t('wizard-twitter') }}</span>
              <CustomInputUrl v-model:value="userDataNotProvidedByMbf.twitter"
                              prefix="https://x.com/"
                              v-bind:place-holder="$t('twitter-profile-url')"></CustomInputUrl>
            </div>
          </tab-content>

          <tab-content title="Instagram" class="tab-content">
            <div class="tab-content-input-wrapper">
              <span>{{ $t('wizard-instagram') }}</span>
              <CustomInputUrl v-model:value="userDataNotProvidedByMbf.instagram"
                              prefix="https://instagram.com/"
                              v-bind:place-holder="$t('instagram-profile-url')"></CustomInputUrl>
            </div>
          </tab-content>

          <tab-content title="Facebook" class="tab-content">
            <div class="tab-content-input-wrapper">
              <span>{{ $t('wizard-facebook') }}</span>
              <CustomInputUrl v-model:value="userDataNotProvidedByMbf.facebook"
                              prefix="https://facebook.com/"
                              v-bind:place-holder="$t('facebook-profile-url')"></CustomInputUrl>
            </div>
          </tab-content>

          <tab-content :title=" $t('current-headline')" class="tab-content">
            <div class="tab-content-input-wrapper">
              <span>{{ $t('wizard-headline') }}</span>
              <CustomInputTextArea style="margin-top: 40px" v-bind:rows="1"
                                   v-model:value="userDataNotProvidedByMbf.headline"
                                   v-bind:place-holder="$t('current-headline')"
                                   v-bind:max-length="255"></CustomInputTextArea>
            </div>


          </tab-content>
        </form-wizard>
      </custom-dialog>

      <!-- Logout User Dialog -->
      <custom-dialog :id="'after-logout-profile-dialog'" :on-submit="redirectAfterProfileDelete"
                     :on-cancel="redirectAfterProfileDelete"
                     :submit-button-text="$t('dialog-ok')" ref="logoutSuccessDialog">
            <span class="header">
                {{ $t('logout-successful') }}
            </span>
      </custom-dialog>

      <!-- Delete Profile Dialogs   -->
      <custom-dialog :id="'delete-profile-dialog'" ref="deleteProfileDialog" :on-submit="deleteProfile"
                     :submit-button-text="$t('profile-delete')">
        <span class="header"> {{ $t('profile-delete') }} </span>
        <div v-html="$t('confirm-profile-delete')"></div>
      </custom-dialog>
      <custom-dialog :id="'confirm-delete-all-dialog'" ref="confirmDeleteAllDialog"
                     :on-submit="deleteUserFromAllDevices"
                     :submit-button-text="$t('profile-delete-all')"
                     :on-second-button-submit="deleteUserOnCurrentDevice"
                     :second-button-text="$t('profile-delete-device')">
        <span class="header"> {{ $t('profile-delete-completely') }} </span>
      </custom-dialog>
      <custom-dialog :id="'after-delete-profile-dialog'" :on-submit="redirectAfterProfileDelete"
                     :on-cancel="redirectAfterProfileDelete"
                     :submit-button-text="$t('dialog-ok')" ref="deleteSuccessDialog">
            <span class="header">
                {{ $tc('still-bound-to-devices', boundDevicesCount) }}
            </span>
      </custom-dialog>

      <!-- Reconfirm E-Mail  Dialog   -->
      <custom-dialog :id="'reconfirm-dialog'" ref="reconfirmDialog" :on-submit="loadUser"
                     :submit-button-text="$t('email-confirmed')"
                     :on-second-button-submit="resendEmail"
                     :can-close-dialog-validation-function="canCloseReConfirmDialog"
                     :second-button-text="$t('resend-email')">
        <span class="header"> {{ $t('please-confirm-your-mail') }} </span>
        <div class="reconfirm-dialog-container">
          <i class="fal fa-envelope fa-2x"></i>
          <div class="reconfirm-dialog-text-container">
            <div class="reconfirm-dialog-text"
                 v-html="$tc('please-confirm-your-mail-text',undefined,{email : userData.email})"></div>
          </div>
        </div>
      </custom-dialog>

      <!-- Change E-Mail Dialog -->
      <custom-dialog v-bind:id="'changeEmailDialog'" ref="changeEmailDialog" v-bind:disable-buttons="true"
                     :can-close-dialog-validation-function="canCloseReConfirmDialog"
                     v-bind:onCancel="onChangeEmailDialogCanceled">
        <span class="header">{{ $t('change-email-dialog-header') }}</span>
        <form class="changeEmailDialogForm" v-on:submit.prevent="saveChangedEmail()">
          <CustomInputText v-model:value="newEmail" v-bind:place-holder="$t('email')"
                           v-bind:custom-type="'email'"
                           v-bind:required="true"></CustomInputText>
          <custom-button v-bind:width="250" v-bind:onClicked="submitChangeEmailForm"
                         v-bind:icon="'fal fa-chevron-right fa-2x'">
            {{ $t('change-email') }}
          </custom-button>
          <input hidden style="display: none" id="submit-change-mail-input" type="submit">
        </form>
      </custom-dialog>

      <!-- Enable Video Chat Dialog -->
      <custom-dialog :id="'enable-video-chat-dialog'" ref="enableVideoChatDialog"
                     :on-submit="enableOrDisableVideoChat(true)"
                     :submit-button-text="$t('dialog-yes')"
                     :on-second-button-submit="enableOrDisableVideoChat(false)"
                     :second-button-text="$t('dialog-no')"
                     :on-cancel="enableOrDisableVideoChat(false)">

        <span class="header">{{ $t('video-chat-enable') }}</span>
        <span class="enable-video-chat-text">
                {{ $t('video-chat-desc') }}<br>
            </span>
        <div class="enable-video-chat-text question">
          {{ $t('video-chat-question') }}
        </div>

        <!-- p>TODO datenschutztexte ?</p -->
      </custom-dialog>

      <!-- Save unsaved Changes Dialog -->
      <custom-dialog :id="'save-changes-dialog'" ref="saveChangesDialog"
                     :on-submit="saveChangesAfterConfirmWithRedirect"
                     :on-second-button-submit="closeSavedChangesWithRedirect"
                     :submit-button-text="$t('dialog-yes')"
                     :second-button-text="$t('dialog-no')">
        <span class="header">{{ $t('confirm-theme-changes') }}</span>
      </custom-dialog>

      <div class="side-header-wrapper">
        <div class="side-header">{{ $t('your-profile') }}</div>
        <div class="roleName" v-if="userData.roleName">
          <span>{{ userData.roleName }}</span>
        </div>
      </div>


      <div class="inputs" v-bind:class="{'mark-required':markRequired}">
        <div class="profile-privacy-disclaimer">{{ $t('profile-privacy-disclaimer') }}</div>
        <form name="form" id="form" class="form" v-on:submit.prevent="saveUserData()" v-if="!(mq.current === 'mobile')">
          <div class="left-side">
            <MBFSelect v-model:selected-value="userData.title" v-bind:options="myBookFairTitles"
                       v-bind:place-holder="$t('title')" v-if="$isMyBookFair"></MBFSelect>
            <CustomInputText v-model:value="userData.title" v-bind:place-holder="$t('title')"
                             v-if="!$isMyBookFair"></CustomInputText>
            <CustomInputText v-model:value="userData.firstName" v-bind:place-holder="$t('firstName')" v-bind:disabled="true"
                             v-bind:required="true"></CustomInputText>
            <CustomInputText v-model:value="userData.lastName" v-bind:place-holder="$t('lastName')" v-bind:disabled="true"
                             v-bind:required="true"></CustomInputText>
            <CustomInputText v-model:value="userData.organization" v-bind:required="companyRequired"
                             v-bind:place-holder="$t('organization')"></CustomInputText>
            <MBFSelect v-model:selected-value="userData.country" v-bind:options="countryList"
                       v-bind:place-holder="$t('country')" v-if="showCountrySelect" v-bind:option-selector="'iso_2'"
                       v-bind:translate-function="getDisplayValueForCountry"></MBFSelect>

            <CustomInputText v-model:value="userData.position"
                             v-bind:place-holder="$t('position')"></CustomInputText>
            <CustomInputText v-model:value="userData.tel" v-bind:place-holder="$t('phone')"></CustomInputText>
            <div class="email-container">
              <CustomInputText v-model:value="userData.email" v-bind:place-holder="$t('email')"
                               v-bind:disabled="$disableEMailInput"
                               v-bind:custom-type="'email'"
                               v-bind:required="true"></CustomInputText>
              <i v-if="userData && userData.pending_email" class="fas fa-exclamation-triangle fa-lg"
                 v-bind:title="$t('unconfirmed-email-warning-text',{email:userData.pending_email})"></i>
            </div>
            <CustomInputUrl v-model:value="userData.web" v-bind:place-holder="$t('website-url')"></CustomInputUrl>
            <CustomInputUrl v-model:value="userData.linkedin"
                            prefix="https://www.linkedin.com/in/"
                            v-bind:place-holder="$t('linkedin-profile-url')"></CustomInputUrl>
            <CustomInputUrl v-model:value="userData.twitter"
                            prefix="https://x.com/"
                            v-bind:place-holder="$t('twitter-profile-url')"></CustomInputUrl>
            <CustomInputUrl v-model:value="userData.instagram"
                            prefix="https://instagram.com/"
                            v-bind:place-holder="$t('instagram-profile-url')"></CustomInputUrl>
            <CustomInputUrl v-model:value="userData.facebook"
                            prefix="https://facebook.com/"
                            v-bind:place-holder="$t('facebook-profile-url')"></CustomInputUrl>


            <span>* {{ $t('required-fields') }} </span>

            <input style="display: none" hidden id="submit-input" type="submit">
          </div>

          <div class="right-side">
            <div class="image">
              <span>{{ $t('profile-image') }}</span>
              <img :src="getImage()" alt="Profilbild" ref="img"
                   v-on:error="$refs.img.src = fallbackProfileImageForTemplate"
                   id="profile-image">

              <div class="delete-icon-container" v-if="(userData.photo || selectedProfileImage) && canDeleteImage()"
                   @click="deleteImg()"><i class="fal fa-trash-alt fa-2x"></i></div>


            </div>
            <div class="own-profile-links">
              <custom-button :onClicked="openFilePickerDialog" :icon="'fal fa-arrow-to-top fa-2x'"
                             class="secondary-button upload-profile-picture-button"
                             :backgroundColor="'var(--dark-button-color)'"
                             :iconBackGroundColor="'var(--dark-button-icon-color)'">
                <input name="profile-image-input" id="profile-image-input" hidden type="file"
                       accept="image/png, image/jpeg"
                       v-on:change="onProfileImageChosen">
                {{ $t('picture-upload') }}
                <span class="picture-upload-tooltip">{{ getMaxImageSizeTooltip() }}</span>
              </custom-button>
            </div>


            <CustomInputTextArea style="margin-top: 40px" v-bind:rows="1" v-model:value="userData.headline"
                                 v-bind:place-holder="$t('current-headline')"
                                 v-bind:max-length="255"></CustomInputTextArea>


            <custom-check-box v-model:value="userData.show_contact_data"
                              v-bind:checkbox-text="$t('show-contact-data')"
                              v-if="!isLoading && showContactDataAllowed">
              <label class="enable-video-chat-label">{{ $t('show-contact-data') }}</label>
            </custom-check-box>
            <div class="video-chat-requirements" v-if="showContactDataAllowed">
              <i class="fas fa-info-circle fa-2x"></i>
              <div>{{ $t('show-contact-data-description') }}</div>
            </div>

            <custom-check-box v-model:value="userData.video_chat_allowed"
                              v-bind:checkbox-text="$t('enable-video-chat')" v-if="!isLoading && $enableVideoChat">
              <label class="enable-video-chat-label">{{ $t('enable-video-chat') }}</label>
            </custom-check-box>

            <custom-check-box v-model:value="isVisibleToOthers"
                              v-bind:checkbox-text="$t('profile-visible-to-others')"
                              v-if="!isLoading && showVisibilityCheckbox">
              <label class="enable-video-chat-label">{{ $t('profile-visible-to-others') }}</label>
            </custom-check-box>


            <custom-check-box v-model:value="scheduleHidden"
                              v-bind:checkbox-text="$t('schedule_hidden')"
                              class="schedule-hidden-checkbox"
                              v-if="!isLoading && showScheduleHiddenCheckbox">
              <label class="schedule-hidden-checkbox-label">{{ $t('schedule_hidden') }}</label>
              <span class="enable-video-chat-label-tooltip">{{ $t('schedule_hidden_tooltip') }}</span>
            </custom-check-box>


            <div class="push-warning" v-if="showPushWarning() && $enableVideoChat">
              <i class="fas fa-exclamation-triangle fa-2x"></i>
              <div>{{ $t('video-push-warning') }}</div>
            </div>
            <div v-if="showPushHint() && $enableVideoChat">
              <div class="push-hint">
                <i class="fas fa-exclamation-triangle fa-2x"></i>
                <div>{{ $t('video-push-hint') }}</div>
              </div>
              <custom-button class="push-enable-button" :onClicked="registerForPushes"
                             :icon="'fal fa-comment-check fa-2x'">
                {{ $t('enable-push') }}
              </custom-button>
            </div>
            <div class="video-chat-requirements" v-if="$enableVideoChat">
              <i class="fas fa-info-circle fa-2x"></i>
              <div>{{ $t('video-chat-requirements') }}</div>
            </div>

            <div class="own-profile-links">
              <div class="show-profile-container">
                <div class="show-profile-header">{{ $t('how-others-see-profile') }}</div>
                <custom-button class="secondary-button" :onClicked="openProfileDialog"
                               :icon="'fal fa-user-circle fa-2x'">
                  {{ $t('show-profile') }}
                </custom-button>
              </div>

              <div class="copy-profile-link-container">
                <div class="copy-profile-link-header">{{ $t('profile-link-copy-header') }}</div>
                <custom-button class="secondary-button" :onClicked="copyProfileUrlToClipboard"
                               :icon="'fal fa-copy fa-2x'">
                  {{ $t('profile-link-copy') }}
                </custom-button>
              </div>

              <div class="logout-container">
                <div class="logout-header">{{ $t('logout-header') }}</div>
                <custom-button class="secondary-button" :onClicked="onLogoutUserClicked"
                               :icon="'fal fa-sign-out fa-2x'">
                  {{ $t('logout-user') }}
                </custom-button>
              </div>

              <custom-button class="deleteButton" :onClicked="onDeleteProfileClicked" :icon="'fal fa-trash-alt fa-2x'">
                {{ $t('profile-delete') }}
              </custom-button>
            </div>


          </div>
          <div class="save-button">
            <custom-button class="primary-button" :onClicked="submitForm" :icon="'fal fa-chevron-right fa-2x'">
              {{ $t('saving') }}
            </custom-button>
          </div>
        </form>

        <form name="form" id="formMobile" class="form" v-on:submit.prevent="saveUserData()"
              v-if="(mq.current === 'mobile')">

          <div class="right-side">
            <div class="image">
              <span>{{ $t('profile-image') }}</span>
              <img :src="getImage()" alt="Profilbild" ref="img"
                   v-on:error="$refs.img.src = fallbackProfileImageForTemplate"
                   id="profile-image">

              <div class="delete-icon-container" v-if="userData.photo && canDeleteImage()"
                   @click="deleteImg()"><i class="fal fa-trash-alt fa-2x"></i></div>


            </div>
            <custom-button :onClicked="openFilePickerDialog" :icon="'fal fa-arrow-to-top fa-2x'"
                           class="secondary-button upload-profile-picture-button"
                           :backgroundColor="'var(--dark-button-color)'"
                           :iconBackGroundColor="'var(--dark-button-icon-color)'">
              <input name="profile-image-input" id="profile-image-input" hidden type="file"
                     accept="image/png, image/jpeg"
                     v-on:change="onProfileImageChosen">
              {{ $t('picture-upload') }}
              <span class="picture-upload-tooltip">{{ getMaxImageSizeTooltip() }}</span>
            </custom-button>


            <CustomInputTextArea style="margin-top: 40px" v-bind:rows="1" v-model:value="userData.headline"
                                 v-bind:place-holder="$t('current-headline')"
                                 v-bind:max-length="255"></CustomInputTextArea>


            <custom-check-box v-model:value="userData.video_chat_allowed"
                              v-bind:checkbox-text="$t('enable-video-chat')" v-if="!isLoading && $enableVideoChat">
              <label class="enable-video-chat-label">{{ $t('enable-video-chat') }}</label>
            </custom-check-box>

            <custom-check-box v-model:value="isVisibleToOthers"
                              v-bind:checkbox-text="$t('profile-visible-to-others')"
                              v-if="!isLoading && showVisibilityCheckbox">
              <label class="enable-video-chat-label">{{ $t('profile-visible-to-others') }}</label>
            </custom-check-box>

            <custom-check-box v-model:value="scheduleHidden" style="margin-top: 12px"
                              v-bind:checkbox-text="$t('schedule_hidden')"
                              v-if="!isLoading && showScheduleHiddenCheckbox">
              <label class="enable-video-chat-label">{{ $t('schedule_hidden') }}</label>
            </custom-check-box>

            <div class="push-warning" v-if="showPushWarning() && $enableVideoChat">
              <i class="fas fa-exclamation-triangle fa-2x"></i>
              <div>{{ $t('video-push-warning') }}</div>
            </div>
            <div v-if="showPushHint() && $enableVideoChat">
              <div class="push-hint">
                <i class="fas fa-exclamation-triangle fa-2x"></i>
                <div>{{ $t('video-push-hint') }}</div>
              </div>
              <custom-button class="push-enable-button" :onClicked="registerForPushes"
                             :icon="'fal fa-comment-check fa-2x'">
                {{ $t('enable-push') }}
              </custom-button>
            </div>
            <div class="video-chat-requirements" v-if="$enableVideoChat">
              <i class="fas fa-info-circle fa-2x"></i>
              <div>{{ $t('video-chat-requirements') }}</div>
            </div>
          </div>

          <div class="left-side">

            <MBFSelect v-model:selected-value="userData.title" v-bind:options="myBookFairTitles"
                       v-bind:place-holder="$t('title')" v-if="$isMyBookFair"></MBFSelect>
            <CustomInputText v-model:value="userData.firstName" v-bind:place-holder="$t('firstName')" v-bind:disabled="true"
                             v-bind:required="true"></CustomInputText>
            <CustomInputText v-model:value="userData.lastName" v-bind:place-holder="$t('lastName')" v-bind:disabled="true"
                             v-bind:required="true"></CustomInputText>
            <CustomInputText v-model:value="userData.organization" v-bind:required="companyRequired"
                             v-bind:place-holder="$t('organization')"></CustomInputText>
            <MBFSelect v-model:selected-value="userData.country" v-bind:options="countryList"
                       v-bind:place-holder="$t('country')" v-if="showCountrySelect" v-bind:option-selector="'iso_2'"
                       v-bind:translate-function="getDisplayValueForCountry"></MBFSelect>
            <CustomInputText v-model:value="userData.position"
                             v-bind:place-holder="$t('position')"></CustomInputText>
            <CustomInputText v-model:value="userData.tel" v-bind:place-holder="$t('phone')"></CustomInputText>
            <CustomInputText v-model:value="userData.email" v-bind:place-holder="$t('email')"
                             v-bind:disabled="$disableEMailInput"
                             v-bind:custom-type="'email'"
                             v-bind:required="true"></CustomInputText>
            <CustomInputUrl v-model:value="userData.web" v-bind:place-holder="$t('website-url')"></CustomInputUrl>
            <CustomInputUrl v-model:value="userData.linkedin"
                            prefix="https://www.linkedin.com/in/"
                            v-bind:place-holder="$t('linkedin-profile-url')"></CustomInputUrl>
            <CustomInputUrl v-model:value="userData.twitter"
                            prefix="https://x.com/"
                            v-bind:place-holder="$t('twitter-profile-url')"></CustomInputUrl>
            <CustomInputUrl v-model:value="userData.instagram"
                            prefix="https://instagram.com/"
                            v-bind:place-holder="$t('instagram-profile-url')"></CustomInputUrl>
            <CustomInputUrl v-model:value="userData.facebook"
                            prefix="https://facebook.com/"
                            v-bind:place-holder="$t('facebook-profile-url')"></CustomInputUrl>


            <span>* {{ $t('required-fields') }} </span>


            <div class="own-profile-links">
              <div class="show-profile-container">
                <div class="show-profile-header">{{ $t('how-others-see-profile') }}</div>
                <custom-button class="secondary-button" :onClicked="openProfileDialog"
                               :icon="'fal fa-user-circle fa-2x'">
                  {{ $t('show-profile') }}
                </custom-button>
              </div>

              <div class="copy-profile-link-container">
                <div class="copy-profile-link-header">{{ $t('profile-link-copy-header') }}</div>
                <custom-button class="secondary-button" :onClicked="copyProfileUrlToClipboard"
                               :icon="'fal fa-copy fa-2x'">
                  {{ $t('profile-link-copy') }}
                </custom-button>
              </div>

              <div class="logout-container">
                <div class="logout-header">{{ $t('logout-header') }}</div>
                <custom-button class="secondary-button" :onClicked="onLogoutUserClicked"
                               :icon="'fal fa-sign-out fa-2x'">
                  {{ $t('logout-user') }}
                </custom-button>
              </div>

              <custom-button class="deleteButton" :onClicked="onDeleteProfileClicked" :icon="'fal fa-trash-alt fa-2x'">
                {{ $t('profile-delete') }}
              </custom-button>
            </div>


            <custom-button class="primary-button" :onClicked="submitForm" :icon="'fal fa-chevron-right fa-2x'">
              {{ $t('saving') }}
            </custom-button>

            <input style="display: none" hidden id="submit-input" type="submit">
          </div>
        </form>
      </div>


      <themes-own-profile :user-themes="userData.themes" v-if="!isLoading"
                          v-bind:preferred_booth="userData.preferred_booth"
                          v-on:titleClicked="openChangeThemes"></themes-own-profile>
    </template>
  </div>
</template>
<script>
import backend from '../mm-backend'
import themes from '../themes/themes-helper';
import localStorageHelper from "../localstorage/local-storage";
import {countriesStorage, eventBus, logger} from '../main';
import fallbackProfileImage from '../assets/img/person.svg';
import {deleteDB} from 'idb';
import {isNotificationDefault, isNotificationDenied, isNotificationSupported, register} from '../push-backend';
import ThemesRoot from "../themes/profile-own/themes-own-profile";
import ThemesOwnProfile from "../themes/profile-own/themes-own-profile";
import CustomCheckBox from "../components/inputs/CustomCheckBox";
import CustomInputText from "../components/inputs/CustomInputText";
import CustomInputTextArea from "../components/inputs/CustomInputTextArea";
import SelectThemes from "../themes/select/select-themes";
import CustomInputUrl from "../components/inputs/CustomInputUrl";
import MBFSelect from "../components/inputs/MBFSelect";
import {deepCopy, isDefined} from "../utils";
import {User} from "@/entities/User";

export default {
  inject: ["mq"],
  components: {
    SelectThemes,
    CustomInputTextArea,
    CustomInputText,
    CustomCheckBox,
    ThemesOwnProfile,
    ThemesRoot,
    CustomInputUrl,
    MBFSelect
  },
  beforeRouteLeave(to, from, next) {
    if (this.selectThemes) {
      const selectedThemes = this.$refs.selectThemes.getSelectedThemes();
      const userThemes = this.$refs.selectThemes.userThemes;
      if (JSON.stringify(userThemes) !== JSON.stringify(selectedThemes)) {
        this.$refs.confirmThemesDialog.openDialog(next);
      } else {
        this.closeThemeSelectWithRedirect(next);
      }
    } else {
      if (this.hasUnsavedChanges() && document.getElementById((this.mq.current === 'mobile') ? 'formMobile' : 'form').checkValidity()) {
        this.$refs.saveChangesDialog.openDialog(next);
      } else {
        next();
      }
    }
  },
  data() {
    return {
      isLoading: true,
      userData: {},
      initialUserData: {},
      markRequired: false,
      isVisibleToOthers: true,
      scheduleHidden: true,
      fallbackProfileImageForTemplate: fallbackProfileImage,
      active_days: {},
      myBookFairTitles: this.$getCurrentLanguage() === 'en' ? ['Dr', 'Prof', 'Prof Dr'] : ['Dr.', 'Prof.', 'Prof. Dr.'],
      lang: this.$getCurrentLanguage(),
      countryList: countriesStorage.getCountryList(),
      companyRequired: process.env.VUE_APP_COMPANY_REQUIRED === 'true',
      showCountrySelect: process.env.VUE_APP_SHOW_COUNTRY_SELECT === 'true',
      deviceId: localStorageHelper.getDeviceId(),
      boundDevicesCount: undefined,
      selectedProfileImage: undefined,
      userDataNotProvidedByMbf: {
        position: undefined,
        web: undefined,
        linkedin: undefined,
        tel: undefined,
        headline: undefined,
        twitter: undefined,
        instagram: undefined,
        facebook: undefined,
      },
      selectThemes: false,
      selectThemesStartTabId: themes.getStartTabId(),
      showContactDataAllowed: process.env.VUE_APP_ALLOW_SHOW_CONTACT_DATA === 'true',
      showVisibilityCheckbox: process.env.VUE_APP_SHOW_VISIBILITY_CHECKBOX === 'true',
      showScheduleHiddenCheckbox: process.env.VUE_APP_SHOW_SCHEDULE_HIDDEN_CHECKBOX === 'true',
      newEmail: undefined
    }
  },
  beforeMount() {
    eventBus.on('visibilitychange', this.visibilityChange)
    eventBus.on('mbf-themes-updated', function (userThemes) {
      this.userData.themes = userThemes;
    }.bind(this));
    eventBus.on('themes-edited', this.themesEdited)
    this.loadUser();
    document.addEventListener('keyup', this.onKeyUp);
  },
  beforeUnmount() {
    document.removeEventListener('keyup', this.onKeyUp);
    eventBus.off('mbf-themes-updated');
    eventBus.off('themes-edited', this.themesEdited);
    backend.cancelRequests();
  },
  methods: {
    onKeyUp(e) {
      if (e.key === 's' && (e.ctrlKey)) {
        e.preventDefault();
        this.submitForm();
      }
    },
    themesEdited(themes) {
      this.userData.themes = themes;
    },
    hasUnsavedChanges() {
      for (const [key, value] of Object.entries(this.userData)) {
        if (JSON.stringify(this.initialUserData[key]) !== JSON.stringify(value)) {
          return true;
        }
      }
      if (this.isVisibleToOthers != this.getIsVisibleToOthers(this.userData)) {
        return true;
      }
      if (this.scheduleHidden !== this.getScheduleHidden(this.userData)) {
        return true;
      }
      return false;
    },
    setUserData(data) {
      this.userData = data;
      this.initialUserData = deepCopy(data);
      this.isVisibleToOthers = this.getIsVisibleToOthers(this.userData);
      this.scheduleHidden = this.getScheduleHidden(this.userData);
    },
    getIsVisibleToOthers(userData) {
      return isDefined(userData.hidden) ? !userData.hidden : true;
    },
    getScheduleHidden(userData) {
      return isDefined(userData.schedule_hidden) ? !userData.schedule_hidden : true;
    },
    loadUser() {
      const self = this;
      backend.me().then(function (resp) {
        const confirmed = resp.data.confirmed;
        if (!confirmed) {
          if (isDefined(localStorageHelper.getUser())) {
            self.setUserData(localStorageHelper.getUser());
          }
          localStorageHelper.setUserConfirmed(false);
          self.$toasted.info(self.$t('email-not-confirmed'), {
            timeout: 2000,
            position: "top-center"
          });
          self.showReconfirmDialog();
        } else {
          self.setUserData(resp.data.user);
          if (!localStorageHelper.getAlreadyVisited()) {
            let showCompleteWizardDialog = true;
            for (const [key, value] of Object.entries(self.userDataNotProvidedByMbf)) {
              if (isDefined(self.userData[key])) {
                showCompleteWizardDialog = false;
              }
            }
            if (showCompleteWizardDialog && process.env.VUE_APP_ENABLE_PROFILE_CREATE !== 'true') {
              self.$refs.completeProfilewizardDialog.openDialog();
            } else {
              if (self.$enableVideoChat && !isDefined(self.userData.video_chat_enabled) || self.userData.video_chat_enabled === "") {
                self.showEnableVideoChatDialog();
              }
            }
          }

          localStorageHelper.setUserConfirmed(true);

          localStorageHelper.setUser(resp.data.user);
          self.closeReConfirmDialog();
          if (self.$isMyBookFair && (!localStorageHelper.getUserCreatedManually() || localStorageHelper.getUserCreatedManually() === 'false')) {
            themes.checkForThemeChanges();
          }
          self.userData.video_chat_allowed = self.userData.video_chat_enabled;
          self.setUserData(self.userData);
        }
        self.$forceUpdate();
        self.isLoading = false; //loading finished
        eventBus.emit('already-visited');
      }, error => {
        logger.error(error)
        self.isLoading = false;
      });
    },
    canCloseReConfirmDialog() {
      return localStorageHelper.getUserConfirmed();
    },
    getImage() {
      if(isDefined(this.selectedProfileImage)){
        return this.selectedProfileImage;
      }
      return this.userData.photo ? this.userData.photo : fallbackProfileImage;
    },
    deleteImg() {
      const self = this;
      backend.deleteUserProfilePicture().then(resp => {
        self.$toasted.success(self.$t('profile-picture-delete-success'));
        this.userData.photo = undefined;
        this.selectedProfileImage = undefined;
      }, error => {
        self.$toasted.error(self.$t('profile-picture-delete-error'));
      });
    },
    onLogoutUserClicked() {
      const self = this;
      backend.logoutUser().then(resp => {
        self.clearUserDataAfterProfileDelete();
        self.showLogoutSuccessDialog();
      });
    },
    onDeleteProfileClicked() {
      this.$refs.deleteProfileDialog.openDialog();
    },
    deleteProfile() {
      const self = this;
      backend.requestUserDelete().then(resp => {
        const remainingDevices = resp.data;
        self.boundDevicesCount = resp.data;
        if (remainingDevices > 0) {
          self.showDeleteAllProfileDialog();
        } else {
          self.clearUserDataAfterProfileDelete();
          self.showDeleteProfileSuccessDialog();
        }
      });
    },
    deleteUserFromAllDevices() {
      const self = this;
      backend.deleteUserOnAllDevices().then(resp => {
        self.boundDevicesCount = resp.data;
        self.clearUserDataAfterProfileDelete();
        self.showDeleteProfileSuccessDialog();
      });
    },
    deleteUserOnCurrentDevice() {
      const self = this;
      backend.deleteUserFromCurrentDevice().then(resp => {
        self.boundDevicesCount = resp.data;
        self.clearUserDataAfterProfileDelete();
        self.showDeleteProfileSuccessDialog();
      });
    },
    clearUserDataAfterProfileDelete() {
      localStorageHelper.clear();
      const self = this;
      if ('serviceWorker' in navigator && navigator.serviceWorker) {
        if (navigator.serviceWorker.controller) {
          navigator.serviceWorker.controller.postMessage({cmd: 'delete'});
        } else {
          navigator.serviceWorker.getRegistration().then(function (serviceWorkerRegistration) {
            if (serviceWorkerRegistration) {
              serviceWorkerRegistration.unregister().then(function (boolean) {
                self.deleteDatabase();
              });
            }
          });
        }
      } else {
        this.deleteDatabase();
      }
    },
    async deleteDatabase() {
      await deleteDB('egcf', {
        blocked() {
          logger.log('blocked');
        },
      });
    },
    onChangeEmailDialogCanceled() {
      this.closeChangeEmailDialog();
      this.showReconfirmDialog();
    },
    onEmailChangedClicked() {
      this.closeReConfirmDialog();
      this.showChangeEmailDialog();
    },
    showChangeEmailDialog() {
      this.newEmail = localStorageHelper.getUser().email;
      this.$refs.changeEmailDialog.openDialog();
    },
    showDeleteAllProfileDialog() {
      this.$refs.confirmDeleteAllDialog.openDialog();
    },
    showLogoutSuccessDialog() {
      this.$refs.logoutSuccessDialog.openDialog();
    },
    showDeleteProfileSuccessDialog() {
      this.$refs.deleteSuccessDialog.openDialog();
    },
    showEnableVideoChatDialog() {
      this.$refs.enableVideoChatDialog.openDialog();
    },
    closeChangeEmailDialog() {
      if (this.$refs.changeEmailDialog.isOpen()) {
        this.$refs.changeEmailDialog.closeDialogFromOutside();
      }
    },
    closeEnableVideoChatDialog() {
      if (this.$refs.enableVideoChatDialog.isOpen()) {
        this.$refs.enableVideoChatDialog.closeDialogFromOutside();
      }
    },
    closeProfileWizardDialog() {
      if (this.$refs.completeProfilewizardDialog.isOpen()) {
        this.$refs.completeProfilewizardDialog.closeDialogFromOutside();
      }
    },
    redirectAfterProfileDelete() {
      window.location = process.env.VUE_APP_EXIT_REDIRECT_URL;
    },
    submitChangeEmailForm() {
      document.getElementById('submit-change-mail-input').click();
    },
    submitForm() {
      const submitInput = document.getElementById('submit-input');
      this.markRequired = true;
      if (isDefined(submitInput)) {
        submitInput.click();
      }
    },
    saveUserDataFromwizard() {
      for (const [key, value] of Object.entries(this.userDataNotProvidedByMbf)) {
        this.userData[key] = value;
      }
      this.saveUserData();
      this.closeProfileWizardDialog();
      if (this.$enableVideoChat && !isDefined(this.userData.video_chat_enabled) || this.userData.video_chat_enabled === "") {
        this.showEnableVideoChatDialog();
      }
    },
    saveThemes(container, next) {
      this.userData.themes = container.selectedThemes;
      if (isDefined(container.preferred_booth)) {
        this.userData.preferred_booth = container.preferred_booth
      }
      this.saveUserData(next);
      this.selectThemes = false;
    },
    saveChangedEmail() {
      const self = this;
      self.userData.email = this.newEmail
      backend.saveData(this.deviceId, this.userData, false).then(resp => {
        const response = JSON.parse(resp);
        if (response.error) {
          self.$toasted.error(response.error.message);
        } else {
          self.userData.video_chat_enabled = self.userData.video_chat_allowed;
          self.setUserData(self.userData);
          localStorageHelper.setUser(self.userData);
          if (!response.reconfirm && response.confirmed) {
            if (isDefined(self.$refs.completeProfilewizardDialog)) {
              self.$refs.completeProfilewizardDialog.closeDialogFromOutside();
            }
            self.$toasted.success(self.$t('profile-saved-success'));
            localStorageHelper.setUserConfirmed(true);
            self.$forceUpdate();
          } else {
            localStorageHelper.setUserConfirmed(false);
            self.$refs.changeEmailDialog.closeDialogFromOutside();
            self.showReconfirmDialog();
          }
        }
      });
    },
    saveUserData(next) {
      const self = this;
      self.isLoading = true;
      if (this.showVisibilityCheckbox) {
        self.userData.hidden = !this.isVisibleToOthers;
      }
      if (this.showScheduleHiddenCheckbox) {
        self.userData.schedule_hidden = !this.scheduleHidden;
      }
      backend.registrationCompleted(this.deviceId, this.userData, false).then(resp => {
        const response = JSON.parse(resp);
        if (response.error) {
          self.$toasted.error(response.error.message);
        } else {
          self.userData.video_chat_enabled = self.userData.video_chat_allowed;
          self.setUserData(self.userData);
          localStorageHelper.setUser(self.userData);
          if (!response.reconfirm) {
            if (isDefined(self.$refs.completeProfilewizardDialog)) {
              self.$refs.completeProfilewizardDialog.closeDialogFromOutside();
            }
            self.$toasted.success(self.$t('profile-saved-success'));
            localStorageHelper.setUserConfirmed(true);
            self.$forceUpdate();
            if (next) {
              next();
            }
          } else {
            localStorageHelper.setUserConfirmed(false);
            self.showReconfirmDialog();
          }
        }
        self.isLoading = false;
      }, error => {
        self.isLoading = false;
      });
    },
    canDeleteImage() {
      if (!document.getElementById('profile-image')) {
        return false;
      }
      return document.getElementById('profile-image').src !== 'img/person.svg'
    },
    showReconfirmDialog() {
      this.$refs.reconfirmDialog.openDialog();
      this.$nextTick(() => {
        const changeEmailButton = document.getElementById('changeEmailButton');
        if (process.env.VUE_APP_DISABLE_EMAIL_INPUT === 'true') {
          changeEmailButton.remove();
        } else {
          if (isDefined(changeEmailButton)) {
            changeEmailButton.onclick = this.onEmailChangedClicked;
          }
        }
      });
    },
    closeReConfirmDialog() {
      if (this.$refs.reconfirmDialog) {
        this.$refs.reconfirmDialog.closeDialogFromOutside()
      }
    },
    openFilePickerDialog() {
      document.getElementById('profile-image-input').click();
    },
    onProfileImageChosen(event) {
      const file = event.target.files[0];
      const self = this;
      if (file) {
        if (file.size > process.env.VUE_APP_MAX_FILE_SIZE_FOR_PROFILE_PICTURE) {
          self.$toasted.error(self.$tc('file-size-too-big', {fileSize: process.env.VUE_APP_MAX_FILE_SIZE_FOR_PROFILE_PICTURE_TEXT}));
        } else {
          backend.uploadProfileImage(file).then(resp => {
            const reader = new FileReader();
            reader.addEventListener("load", () => {
              self.selectedProfileImage = reader.result;
            })
            reader.readAsDataURL(file);
            self.$toasted.success(self.$t('profile-picture-saved-success'))
          }, error => {
            self.$toasted.error(self.$t('profile-picture-saved-error'));
          });
        }
      }
    },
    getMaxImageSizeTooltip() {
      return `Max ${process.env.VUE_APP_MAX_FILE_SIZE_FOR_PROFILE_PICTURE_TEXT}`;
    },
    resendEmail() {
      const self = this;
      backend.resendConfirmationEmail().then(resp => {
        self.$toasted.success(self.$t('email-resend'), {
          timeout: 2000,
          position: "top-center"
        });
      });
    },
    onProfileWizardCancel() {
      this.saveUserData();
      if (this.$enableVideoChat && !isDefined(this.userData.video_chat_enabled) || this.userData.video_chat_enabled === "") {
        this.showEnableVideoChatDialog();
      }
    },
    enableOrDisableVideoChat(value) {
      return function () {
        this.closeEnableVideoChatDialog();
        this.userData.video_chat_allowed = value;
        this.userData.video_chat_supported = true;
        this.saveUserData();
      }.bind(this);
    },
    visibilityChange(evt) {
      if (this.$isMyBookFair && document.visibilityState === 'visible' && localStorageHelper.getWentToMyBookFair()) {
        themes.checkForThemeChanges();
        localStorageHelper.deleteWentToMyBookFair();
      }
    },
    showPushWarning: function () {
      return this.userData.video_chat_allowed && isNotificationSupported() && isNotificationDenied();
    },
    showPushHint: function () {
      return this.userData.video_chat_allowed && isNotificationSupported() && isNotificationDefault();
    },
    registerForPushes() {
      const self = this;
      register(localStorageHelper.getDeviceId()).then((deviceToken) => {
        this.$forceUpdate();
        logger.log("register push")
        backend.registerv2(localStorageHelper.getDeviceId(), localStorageHelper.getUser(), false).then(resp => {
          logger.log("Register with Push token ");
        });
      }).catch(error => {
        this.$forceUpdate();
      });
    },
    copyProfileUrlToClipboard() {
      const profileUrl = window.location.href + "/" + this.userData.id;
      const dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = profileUrl;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
      this.$toasted.info(this.$t("profile-link-copied"), {
        position: "top-center",
        duration: 2000
      });
    },
    openProfileDialog() {
      const userDataCopy = new User(deepCopy(this.userData));
      if(isDefined(this.selectedProfileImage)){
         userDataCopy.photo = this.selectedProfileImage;
      }
      eventBus.emit('open-profile-dialog', {
        user: userDataCopy,
        isRecommendation: false
      });
    },
    openChangeThemes(startTabId) {
      this.selectThemesStartTabId = startTabId;
      this.selectThemes = true;
    },
    saveThemesAfterConfirmWithRedirect(next) {
      const areTabsValid = this.$refs.selectThemes.validateCurrentActiveTab();
      if (areTabsValid === true) {
        this.saveThemes(this.$refs.selectThemes.getSelectedThemes(), next);
      } else {
        this.$refs.selectThemes.showCategoriesNotValidErrorMessage(areTabsValid);
      }
    },
    saveChangesAfterConfirmWithRedirect(next) {
      this.saveUserData(next);
    },
    closeThemeSelect() {
      this.selectThemes = false;
    },
    closeThemeSelectWithRedirect(next) {
      this.selectThemes = false;
      if (next) {
        next();
      }
    },
    closeSavedChangesWithRedirect(next) {
      if (next) {
        next();
      }
    },
    onSelectThemesClosedByRouter() {
      const selectedThemes = this.$refs.selectThemes.getSelectedThemes();
      const userThemes = this.$refs.selectThemes.userThemes;
      if (JSON.stringify(userThemes) !== JSON.stringify(selectedThemes)) {
        this.$refs.confirmThemesDialog.openDialog();
      } else {
        this.closeThemeSelect();
      }
    },
    getDisplayValueForCountry(country) {
      return country.getDisplayNameByLanguage(this.$getCurrentLanguage());
    }
  }
}
</script>

<style lang="less">

.vue-form-wizard .wizard-header {
  padding-top: 0 !important;
}

.wizard-icon-circle {
  width: 36px !important;
  height: 36px !important;
  font-size: 20px !important;
  border-color: var(--secondary-color) !important;
}

.vue-form-wizard.md .wizard-nav-pills > li.active > a .wizard-icon {
  font-size: 20px;
}

.vue-form-wizard .wizard-btn {
  border-radius: 0px !important;
}

.vue-form-wizard .wizard-nav-pills > li > a {

  padding: 15px 15px 15px 15px !important;

}

.profile-wizard {
  width: 100%;


  .tab-content {
    display: flex;
    flex-direction: row;
    justify-content: center;

    .tab-content-input-wrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      /*min-width: 500px;*/
      min-height: 240px;
      width: 100%;

      > span {
        font-size: 20px;
        font-weight: 700;
        min-height: 70px;
        text-align: left;
      }

      .input-wrapper {
        width: 100%;
        margin-top: 20px;
      }
    }

    .checkbox-wrapper {
      height: 54px;
      margin-bottom: 40px;
      //padding-top: 20px;
      //width: 60%;
    }
  }
}


.change-themes-button {
  margin-top: 60px !important;
}

.upload-profile-picture-button {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.24px;
  line-height: 24px;
}

.enable-video-chat-label, .schedule-hidden-checkbox-label {
  font-weight: 700;
  font-size: 20px;
  margin-left: 10px;
}


.enable-video-chat-label-tooltip {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  visibility: hidden;
  width: 100%;
  position: absolute;
  top: 115%;
  left: 0;
  opacity: 0;
  border-radius: 4px;
  background-color: var(--primary-color);
  color: white;
  z-index: 9999;
  padding: 8px;
  box-sizing: border-box;
  box-shadow: 3px 3px 4px 2px rgba(0, 0, 0, 0.25);
}

.schedule-hidden-checkbox {
  margin-top: 12px;
  position: relative;
  margin-bottom: 24px;
}


.enable-video-chat-label-tooltip:after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 15%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent var(--primary-color) transparent;
}

.schedule-hidden-checkbox:hover {
  .enable-video-chat-label-tooltip {
    visibility: visible;
    opacity: 1;
  }
}

.enable-video-chat-text {
  font-weight: 400;
  text-align: left;
  white-space: pre-line
}

.enable-video-chat-text.question {
  margin: 1em 0;
}

.push-warning, .push-hint {
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  background-color: var(--primary-color);
  margin-top: 10px;
  padding: 8px;

  > i {
    padding: 8px;
  }

  > div {
    margin: 1em 0;
  }
}

.push-warning {
  background-color: var(--primary-color);
}

.push-hint {
  background-color: var(--icon-color);
}

.push-enable-button {
  width: 100%;
}

.own-profile-links {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  .copy-profile-link-header, .show-profile-header {
    font-weight: 700;
    margin-top: 30px;
    color: #333333;
    text-align: left;
  }

}

.upload-profile-picture-button {
  position: relative;

  .picture-upload-tooltip {
    display: flex;
    justify-content: center;
    align-items: center;
    visibility: hidden;
    width: 50%;
    position: absolute;
    top: 115%;
    left: 25%;
    opacity: 0;
    border-radius: 4px;
    background-color: var(--primary-color);
  }

  .picture-upload-tooltip:after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent var(--primary-color) transparent;
  }
}

.upload-profile-picture-button:hover {
  .picture-upload-tooltip {
    visibility: visible;
    opacity: 1;
  }
}

.reconfirm-dialog-container {
  .reconfirm-dialog-text-container {
    display: flex;
    flex-direction: column;

    .custom-button {
      margin: 20px;
    }
  }
}

.reserve-time-container, .reconfirm-dialog-container {
  display: flex;
  flex-direction: row;
  align-items: center;

  > i {
    font-size: 6em;
    color: var(--secondary-color);
    padding: 0 20px 20px;
    margin: 0 10px 10px;
  }

  div {
    padding: 20px;
    margin: 0;
  }
}

.reserve-time-text, .reconfirm-dialog-text {
  text-align: left;
}

.profile-privacy-disclaimer {
  text-align: left;
  font-size: 20px;
  margin-bottom: 20px;
}


</style>
